import { render } from "./TopButton.vue?vue&type=template&id=d38f5dfe"
import script from "./TopButton.vue?vue&type=script&lang=js"
export * from "./TopButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__